import { render, staticRenderFns } from "./DeviceBindblesn.vue?vue&type=template&id=38971b36&scoped=true&"
import script from "./DeviceBindblesn.vue?vue&type=script&lang=js&"
export * from "./DeviceBindblesn.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBindblesn.vue?vue&type=style&index=0&id=38971b36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38971b36",
  null
  
)

export default component.exports